import { TranslationKeys } from '~frontend-common/i18n/english/financial-institution.i18n';

const keys: TranslationKeys = {
  financialInstitution: {
    alternaBank: 'Banque Alterna',
    alternaSavings: 'Caisse Alterna',
    bankofMontreal: 'Banque de Montréal',
    caisseAlliance: 'Caisse Alliance',
    canadianWesternBank: "Banque Canadienne de l'Ouest",
    central1CreditUnion: 'Coopérative de crédit Central 1',
    cibc: 'Banque Canadienne Impériale de Commerce (CIBC)',
    desjardinsGroup: 'Desjardins',
    desjardinsOntarioCreditUnion: 'Caisse Desjardins Ontario',
    equitableBank: 'Banque Équitable',
    hsbcBank: 'Banque HSBC Canada',
    laurentianBank: 'Banque Laurentienne du Canada',
    manulifeBank: 'Banque Manuvie',
    meridianCreditUnion: 'Meridian Credit Union', // Appears to be EN only
    motusbank: 'Motusbank',
    nationalBank: 'Banque Nationale',
    peoplesTrustBank: 'La Compagnie de Fiducie Peoples',
    presidentChoiceBank: 'Banque Choix du Président',
    royalBank: 'Banque Royale du Canada (RBC)',
    scotiabank: 'Banque Scotia',
    tangerineBank: 'Tangerine',
    tdBank: 'Banque Toronto Dominion (TD)',
    vancityBank: 'Banque Vancity',
    wealthOneBank: 'Wealth One Bank', // mainly english-mandarin-cantonese bank
    wealthsimple: 'Wealthsimple',
  },
};

export default keys;
